/**
 * Module Constants and Metadata
 * Frontend constants matching backend modules.py
 */

export const MODULE_SKETCHUP = "MODULE_SKETCHUP"
export const MODULE_VECTORWORKS = "MODULE_VECTORWORKS"
export const MODULE_B2B_PROJECTS = "MODULE_B2B_PROJECTS"

export const MODULE_METADATA: Record<string, {
  name: string
  description: string
  icon: string
  benefits: string[]
  tier_required: string
}> = {
  [MODULE_SKETCHUP]: {
    name: "SketchUp Bridge",
    description: "Real-time synchronisatie met SketchUp voor naadloze 3D workflow",
    icon: "📐",
    benefits: [
      "Live synchronisatie tussen SketchUp en Orion",
      "Automatische BOM generatie uit 3D modellen",
      "Real-time prijsberekening tijdens ontwerp",
      "Bi-directionele data flow"
    ],
    tier_required: "PRO"
  },
  [MODULE_VECTORWORKS]: {
    name: "Vectorworks Bridge",
    description: "Integratie met Vectorworks voor professionele architectuur workflows",
    icon: "🏗️",
    benefits: [
      "XML parsing van Vectorworks projecten",
      "Automatische materiaal mapping",
      "Project import en export",
      "CAD-naadloze integratie"
    ],
    tier_required: "PRO"
  },
  [MODULE_B2B_PROJECTS]: {
    name: "B2B Projecten Module",
    description: "Beheer grotere bouwprojecten. Activeer de B2B-module voor appartementencomplexen, aannemersbeheer en bulk-generatie van keukens.",
    icon: "🏢",
    benefits: [
      "Base Templates beheer voor bulk projecten",
      "Batch unit generatie (100+ appartementen)",
      "Master-to-Unit workflow",
      "Aannemer en projectontwikkelaar beheer",
      "Bulk pricing en configuratie"
    ],
    tier_required: "ENTERPRISE"
  }
}
